export const frCommonNotifications = {
    //* CONTENT NOTIFICATION RECCURENT
    'notifications.recurrent.section.title': 'Relance automatique',
    'notifications.recurrent.tabs.noneLabel': 'Aucune relance',
    'notifications.recurrent.tabs.dateSwitch': 'Date unique',
    'notifications.recurrent.tabs.recursiveTimeSwitch': 'Répétition',

    'notifications.recurrent.date.floatingLabelDate': 'Date de la relance',
    'notifications.recurrent.date.floatingLabelTime': 'Heure de la relance',

    'notifications.recurrent.repeat.floatingLabelRecursiveTime': 'Heure de répétition',
    'notifications.recurrent.repeat.floatingLabelRepeat': 'Tous les XX jours',

    'notifications.recurrent.data.default': '--',

    //* CONTENT NOTIFICATION HISTORY
    'notifications.history.table.title': 'Historique des notifications',
    'notifications.history.table.header.date': 'Date',
    'notifications.history.table.header.type': 'Type',
    'notifications.history.table.header.sender': 'Utilisateur',
    'notifications.history.table.header.shops': 'Nb utilisateurs notifiés',
    'notifications.history.table.empty': "Pas d'historique de notifications",

    'notifications.actions.manualSend.sectionTitle': 'Relance manuelle',
    'notifications.actions.manualBtnlabel': 'Relancer',
};
